import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "name": "Examples",
  "route": "/examples",
  "menu": "Examples",
  "description": "Some examples you can copy & paster into your project."
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Examples`}</h1>
    <br />
    <p>{`Here are some examples you can copy-paste directly in your app. No set up needed. Just the ol' `}<strong parentName="p">{`ctrl+c`}</strong>{` & `}<strong parentName="p">{`ctrl+v`}</strong>{`!`}</p>
    <h2>{`If you have the StyledProvider at the root of your App`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// Example.js
import React from 'react'
import { CookiesBanner } from 'components-extra'

export default () => (
  <CookiesBanner text="Your description">
    <CookiesBanner.Button href="#">More information</CookiesBanner.Button>
    <CookiesBanner.Button onClick={() => alert('do something')}>
      Awesome, I got it!
    </CookiesBanner.Button>
  </CookiesBanner>
)
`}</code></pre>
    <h2>{`If you don't have the StyledProvider at the root of your App`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// Example.js
import React from 'react'
import { CookiesBanner, StyledProvider } from 'components-extra'

export default () => (
  <StyledProvider>
    <CookiesBanner text="Your description">
      <CookiesBanner.Button href="#">More information</CookiesBanner.Button>
      <CookiesBanner.Button onClick={() => alert('do something')}>
        Awesome, I got it!
      </CookiesBanner.Button>
    </CookiesBanner>
  </StyledProvider>
)
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      